import { IpcValueSerializer } from './ipcValueSerializer'
import { LocalTime, LocalDate } from '@js-joda/core'

export class DateSerializer implements IpcValueSerializer {
  typeName = 'Date'
  canSerialize(value: unknown): boolean {
    return value instanceof Date
  }
  serialize(value: unknown): string {
    return (value as Date).toISOString()
  }
  deserialize(value: string): unknown {
    return new Date(value)
  }
}

export class LocalDateSerializer implements IpcValueSerializer {
  typeName = 'LocalDate'
  canSerialize(value: unknown): boolean {
    return value instanceof LocalDate
  }
  serialize(value: unknown): string {
    return (value as LocalDate).toString()
  }
  deserialize(value: string): unknown {
    return LocalDate.parse(value)
  }
}

export class LocalTimeSerializer implements IpcValueSerializer {
  typeName = 'LocalTime'
  canSerialize(value: unknown): boolean {
    return value instanceof LocalTime
  }
  serialize(value: unknown): string {
    return (value as LocalTime).toString()
  }
  deserialize(value: string): unknown {
    return LocalTime.parse(value)
  }
}

export const IPC_VALUE_SERIALIZERS = [new DateSerializer(), new LocalDateSerializer(), new LocalTimeSerializer()]
